import React, { useState } from "react";
import { register } from "../user";
import formIcon from "../assets/images/message-text.png";

const Form = () => {
  const [feedback, setFeedback] = useState({ success: null, message: "" });
  const [loading, setLoading] = useState(false);
  const [showAlert, setShowAlert] = useState(false); // Alert state for name validation

  const [name, setName] = useState("");
  const handleNameChange = (e) => {
    const input = e.target.value;
    const persianStrictRegex =
      /^[\u0621-\u063A\u0641-\u064A\u06A9\u06AF\u067E\u0686\u0698\u06CC\s]*$/;

    if (!persianStrictRegex.test(input)) {
      setShowAlert(true);
    } else {
      setShowAlert(false);
    }

    if (persianStrictRegex.test(input) && input.length <= 15) {
      setName(input);
    }
  };

  const handleFormSubmit = async (event) => {
    setLoading(true);

    event.preventDefault();

    const formData = new FormData(event.target);
    const formObject = {};
    formData.forEach((value, key) => {
      formObject[key] = value;
    });

    const response = await register(formData);

    // console.log(response);
    

    setFeedback({
      result: response.result,
      message: response.message,
    });
    setLoading(false);
  };
  return (
    <div className="formContainer">
      <div className="form">
        <h1>
          <img src={formIcon} alt="form icon" loading="lazy"/>
          دریافت مشاوره خرید
        </h1>
        <form id="auth-form" onSubmit={handleFormSubmit}>
          <div className="form-fields">
            <input
              type="text"
              autoComplete="name"
              inputMode="text"
              className="form-input"
              name="fullName"
              required
              placeholder="نام و نام‌خانوادگی"
              onChange={handleNameChange}
              value={name}
            />

            {showAlert && (
              <p
                className="error-text"
                style={{ color: "red", marginTop: "0", margin: "0" }}
              >
                لطفاً فقط از حروف فارسی استفاده کنید.
              </p>
            )}
            <input
              inputMode="numeric"
              type="text"
              className="form-input mt-4 text-start placeholder-end"
              dir="ltr"
              name="phone"
              required
              placeholder="شماره تلفن همراه"
            />
          </div>
          <button
            type="submit"
            className="form-button mt-8"
            disabled={loading}
            style={{ opacity: loading ? "0.5" : "1" }}
          >
            ثبت درخواست
          </button>
          {feedback.message && (
            <p
              className={`feedback-message mt-4 ${
                feedback.result=="failed" ? "error" :feedback.result=="success"? "success":"error"
              }`}
            >
              {feedback.message}
            </p>
          )}
        </form>
      </div>
    </div>
  );
};

export default Form;
